import React from 'react';
import { Box, Typography } from "@mui/material";
import { getTotalDaysInYear, getDaysCompletedInYear, format2 } from "../../helpers/helper";

function YearCompletedCard({
    year
}) {

    if (!year) return null;

    const totalDays = getTotalDaysInYear(year);
    const daysCompleted = getDaysCompletedInYear(year);
    const completedPercent = Math.min((daysCompleted / totalDays) * 100, 100);

    return (

        <Box
            sx={{
                minHeight: 110,
                p: { xs: 2, lg: 1.5, xl: 2 },
                borderRadius: "20px",
                bgcolor: "background.paper",
                boxShadow: "0px 6px 20px rgba(0,0,0,0.35)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                transition: "all 0.2s ease",
                "&:hover": { transform: "translateY(-2px)" },
            }}
        >
            <Typography
                sx={{
                    fontSize: { xs: 12, lg: 11, xl: 13 },
                    color: "secondary.main",
                    lineHeight: 1.2,
                    mb: 1
                }}
            >
                Year Completed – {year}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 0.5
                }}
            >
                <Typography
                    sx={{
                        fontSize: { xs: 22, lg: 16, xl: 18 },
                        fontWeight: 700,
                        color: "text.primary",
                    }}
                >
                    {format2(completedPercent)} %
                </Typography>

                <Typography
                    sx={{
                        fontSize: { xs: 11, lg: 9, xl: 11 },
                        fontWeight: 500,
                        color: "text.secondary",
                        whiteSpace: "nowrap",
                    }}
                >
                    {daysCompleted} / {totalDays} days
                </Typography>
            </Box>
        </Box>
    );
}


export default React.memo(YearCompletedCard);